// Lets the CANapps Home Tour's "This is your navigation menu" step branch its
// Next based on the live sidebar open/closed state (owned by SharedLayout):
// useHomeTourControl registers a handler that jumps straight to the profile step
// when the sidebar is already open, or to the "open the menu" step when it's
// collapsed. Single-instance app, so a module store is fine.
let advanceFromNav: (() => void) | null = null;

export const setHomeTourAdvanceFromNav = (fn: (() => void) | null): void => {
	advanceFromNav = fn;
};

export const homeTourAdvanceFromNav = (): void => {
	advanceFromNav?.();
};

// Lets the tour close the CANtabs profile dropdown when it moves past the
// profile-menu step (otherwise the open menu would linger, dimmed, behind later
// steps). CanTabHeader registers its close handler here.
let closeProfileMenu: (() => void) | null = null;

export const setHomeTourProfileMenuCloser = (fn: (() => void) | null): void => {
	closeProfileMenu = fn;
};

export const homeTourCloseProfileMenu = (): void => {
	closeProfileMenu?.();
};
